import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceTabOne() {
    return (
        <Container>
            <Row style={{ justifyContent: 'center' }} >
                <Row className='mt-3'>
                    <Col className='service_des_title' > CCTV INSTALLATION </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <p className='service_des_p' >
                            CCTV (closed-circuit television) is a TV framework, principally utilized for both static and mobile surveillance, and is monitored for security purposes. CCTV relies on the planned placement of cameras, and observation of the camera’s input on monitors. Many companies and government agencies use CCTV to monitor and collect video/audio evidence.
                        </p>
                        <p className='service_des_p'>
                            We are equipped with a wide range of security systems from brands such as Hikvision, CP Plus, Dahua, etc. We have the experience necessary to design and implement the system that will meet your needs and budget while giving you the flexibility to expand as your business grows.
                        </p>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_title'> Our Security Solutions Make You Feel Safe: </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_p' >
                        <p className='service_des_p'> We deal with all kinds of security systems, such as IP Network camera installation and many more kinds in Hyderabad. Our services provide- </p>
                        <ul>
                            <li>Security At Your Workplace</li>
                            <li> Security At Your Home</li>
                            <li> Security At Schools </li>
                            <li> Security At Your Streets</li>
                        </ul>
                        <p className='service_des_p'> In this digitalized era, we are one of the best CCTV camera dealers in Hyderabad, offering you top-notch security services at an affordable rate. </p>
                    </Col>
                </Row>
            </Row>
        </Container>
    )
}

export default ServiceTabOne